// src/routes/AdminRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthProvider";
import FullScreenLoader from "../components/ui/FullScreenLoader";

// Roles habilitados para acceder al panel admin
const ADMIN_ROLES = new Set(["owner", "admin", "coach"]);

export default function AdminRoute() {
  const { loading, user, profile } = useAuth();
  const [giveUp, setGiveUp] = useState(false);

  // Si hay sesión pero el perfil todavía no llegó, esperamos un poco (máx. 5s)
  useEffect(() => {
    if (!user || profile) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setGiveUp(false);
      return;
    }
    const t = setTimeout(() => setGiveUp(true), 5000);
    return () => clearTimeout(t);
  }, [user, profile]);

  // 1) Resolviendo auth o perfil
  if (loading || (user && !profile && !giveUp)) {
    return <FullScreenLoader message="Cargando permisos…" />;
  }

  // 2) Sin sesión -> login
  if (!user) return <Navigate to="/login" replace />;

  // 3) Con sesión pero sin perfil a tiempo => salir a /app (evita loader eterno)
  if (!profile) return <Navigate to="/app" replace />;

  // 4) Perfil inactivo => login
  if (!profile.isActive) return <Navigate to="/login" replace />;

  const role = String(profile.role || "")
    .trim()
    .toLowerCase();
  if (!ADMIN_ROLES.has(role)) {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
